export default "__VITE_ASSET__Cb5iDbl9__"